export default "__VITE_ASSET__D11Nro5y__"